import { ReactNode } from 'react';
import { InputAdornment } from '@material-ui/core';
import { AutocompleteComponent } from './Elements/Autocomplete';
import { CheckboxElement } from './Elements/CheckboxElement';
import { FormGroupComponent } from './Elements/FormGroup';
import { MultipleFormGroupElement } from './Elements/MultipleFormGroup';
import { DatePicker, Select, TextField, UserAutocomplete } from '../DesignSystem/Inputs';
import { DateElement } from '@sharedComponents/Field/Elements/Date';
import { LangEnum } from '@enums';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

export const getElementComponent = ({
  schema,
  handleChange,
  autocompleteOptions,
  autocompleteValue,
  handleOnChange,
  form = {},
  handleGroupChange,
  handleChangeInput,
  inputValue = {},
  selectedDate,
  handleDateChange,
  handleChangeCheckbox,
  checked,
  type,
  isUsersLoading,
  lang = LangEnum.ENG,
}) => {
  let element: ReactNode = <></>;

  if (!schema['displayKey'] || form[schema?.displayKey]) {
    switch (type) {
      case 'userAutocomplete': {
        element = (
          <UserAutocomplete
            schema={schema}
            handleChange={handleChange}
            autocompleteOptions={autocompleteOptions}
            autocompleteValue={autocompleteValue}
            handleOnChange={handleOnChange}
            value={form[schema?.key]}
            isUsersLoading={isUsersLoading}
            lang={lang}
          />
        );
        break;
      }
      case 'autocomplete': {
        element = (
          <AutocompleteComponent
            testId={schema?.key}
            schema={schema}
            form={form}
            handleChange={handleChange}
          />
        );
        break;
      }
      case 'select': {
        const currentOption = form[schema?.key]
          ? form[schema?.key]
          : schema?.value || schema?.defaultOption?.value;
        element = (
          <Select
            testId={schema?.key}
            options={schema?.options}
            handleChange={handleChange}
            value={currentOption}
            placeholder={schema?.properties?.placeholder}
            {...schema?.properties}
          />
        );
        break;
      }
      case 'formGroup': {
        element = (
          <FormGroupComponent schema={schema} form={form} handleGroupChange={handleGroupChange} />
        );
        break;
      }
      case 'multipleFormGroup': {
        element = (
          <MultipleFormGroupElement
            schema={schema}
            form={form}
            handleChange={handleChange}
            autocompleteOptions={autocompleteOptions}
            autocompleteValue={autocompleteValue}
            handleOnChange={handleOnChange}
            isUsersLoading={isUsersLoading}
            lang={lang}
          />
        );
        break;
      }
      case 'textarea': {
        element = (
          <TextField
            schema={schema}
            multiline
            onChange={handleChangeInput}
            value={inputValue[schema?.key]}
            defaultValue={schema?.value}
          />
        );
        break;
      }
      case 'textfield': {
        element = (
          <TextField
            schema={schema}
            multiline={false}
            onChange={handleChangeInput}
            value={inputValue[schema?.key]}
            defaultValue={schema?.value}
          />
        );
        break;
      }
      case 'date': {
        element = (
          <MuiPickersUtilsProvider
            utils={MomentUtils}
            locale={lang === LangEnum.ENG ? 'en-gb' : 'ru'}
          >
            <DatePicker
              schema={schema}
              value={selectedDate}
              onChange={handleDateChange}
              lang={lang}
            />
          </MuiPickersUtilsProvider>
        );
        break;
      }
      case 'checkbox': {
        element = (
          <CheckboxElement onChange={handleChangeCheckbox} schema={schema} checked={checked} />
        );
        break;
      }
      case 'text': {
        element = <></>;
        break;
      }
      default: {
        element = 'Component is not defined';
        break;
      }
    }
  }

  return element;
};

export const getGroupElementComponent = ({
  schema,
  formSchema,
  type,
  form,
  value,
  handleCheckboxChange,
  handleInputChange,
  handleDateChange,
  key,
  prefixText,
  properties,
}) => {
  let element = <></>;

  if (
    !schema['displayKey'] ||
    (form[formSchema?.key] ? form[formSchema?.key][schema?.displayKey] : value)
  ) {
    switch (type) {
      case 'checkbox': {
        element = (
          <CheckboxElement
            onChange={handleCheckboxChange(key)}
            schema={schema}
            checked={form[formSchema?.key] ? form[formSchema?.key][key] : value}
          />
        );
        break;
      }
      case 'date': {
        element = <DateElement schema={schema} handleDateChange={handleDateChange(key)} />;
        break;
      }
      default: {
        element = (
          <TextField
            schema={schema}
            InputProps={{
              startAdornment: prefixText ? (
                <InputAdornment position="start">{prefixText}</InputAdornment>
              ) : null,
            }}
            isGroup
            {...properties}
            value={form[formSchema?.key] ? form[formSchema?.key][key] || '' : value}
            onChange={handleInputChange(key)}
          />
        );
      }
    }
  }

  return element;
};
